import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const BookingHistory = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box>
        <Typography variant="h4" gutterBottom>
          Historial de Reservas
        </Typography>
        <Typography variant="body1">
          Aquí se mostrará el historial de reservas del usuario.
        </Typography>
      </Box>
    </Container>
  );
};

export default BookingHistory;